export enum AnchorDate {
    /** Today (or now) - default when no domain-specific date is required. */
    Today = 'today',

    /** Date of the most recent delivery using Division Hierarchy. */
    LastDeliveryByDivision = 'lastDeliveryByDivision',

    /** Date of the most recent delivery using Delivery Center Hierarchy. */
    LastDeliveryByDeliveryCenter = 'lastDeliveryByDeliveryCenter',

    /** Date of the most recent service call. */
    LastServiceCall = 'lastServiceCall',

    /** Date of the most recent invoice. */
    LastInvoice = 'lastInvoice'
};